var React = require('react');

function ModalBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 0C6.28015 0 0 6.28015 0 14C0 21.7199 6.28015 28 14 28C21.7199 28 28 21.7199 28 14C28 6.28015 21.7199 0 14 0ZM17.1581 19.0085C17.6143 19.4646 17.6143 20.202 17.1581 20.6581C16.9306 20.8856 16.632 21 16.3333 21C16.0346 21 15.7359 20.8856 15.5084 20.6581L9.67515 14.8249C9.219 14.3687 9.219 13.6314 9.67515 13.1752L15.5085 7.34185C15.9646 6.8857 16.702 6.8857 17.1581 7.34185C17.6143 7.798 17.6143 8.53535 17.1581 8.9915L12.1496 14L17.1581 19.0085Z","fill":"#E9E9F0"}));
}

ModalBack.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = ModalBack;

ModalBack.default = ModalBack;
